<button *ngIf="!isDisabled" class="option-button" (click)="showOption(itemId+'dots','action-container-active')"
    (blur)="showOption(itemId+'dots','action-container-active')">
    <i class="bi bi-three-dots-vertical"></i>
</button>